import {scrollToRecursion} from "./go-to-anchor";

export function accordion($accordion) {
  let accordionName = 'accordion';
  let accordionSelector = '.' + accordionName;
  let initializedClassName = accordionName + '-initialized';
  let accordion = $accordion || $(accordionSelector);
  let openAccordionBtnSelector = '.toggle-btn';
  let duration = 400;
  let hiddenPartSelector = accordionSelector + '-hidden';
  let activeClass = 'active';

  $('body').on('click', accordionSelector + ' ' + openAccordionBtnSelector, function (e) {
    e.preventDefault();

    let btn = $(this);
    let item = btn.closest('li').toggleClass(activeClass);
    let hidden = item.find(hiddenPartSelector);
    let isActive = !btn.hasClass(activeClass);

    if (isActive) {
      let otherItems = item.siblings().removeClass(activeClass);
      otherItems.find(hiddenPartSelector).slideUp(duration);
      otherItems.find(openAccordionBtnSelector).removeClass(activeClass);
    }

    btn.toggleClass(activeClass);
    hidden.slideToggle(duration/*, function () {
      if(e.originalEvent !== undefined){
        scrollToRecursion(item);
      }
    }*/);
  });

  accordion.each(function () {
    let curAccordion = $(this);

    if (!curAccordion.hasClass(initializedClassName)) {
      curAccordion
        .addClass(initializedClassName)
        .find("> li.open " + openAccordionBtnSelector).trigger('click');
    }
  });
}


// WEBPACK FOOTER //
// ./assets/js/modules/accordion.js